import React, { Fragment, useRef, useState, useEffect } from "react";
import { Link } from "gatsby";
import { HeaderContainer, NavContainer, NavLinksContainer, NavLink, LogoTitle, HamburgerButton } from "./header-styles";
import { Sidebar } from "./sidebar/Sidebar";
import { useMediaQuery } from "../../hooks";
import { MOBILE_WIDTH } from "../../constants";
import { isBrowser } from "../../utils";
import circleMenu from "@iconify/icons-system-uicons/circle-menu";
import { IconLink } from "..";

export const Header = () => {
  const isMobileView = useMediaQuery(MOBILE_WIDTH);
  const isServerSide = !isBrowser();
  const [showSidebar, setShowSidebar] = useState(false);

  const sidebarRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setShowSidebar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarRef]);

  return (
    <Fragment>
      <HeaderContainer>
        <NavContainer>
          <div>
            <Link to="/">
              <LogoTitle>Organic Audio</LogoTitle>
            </Link>
          </div>
          {(!isMobileView || isServerSide) && (
            <NavLinksContainer>
              <NavLink to="/">HOME</NavLink>
              <NavLink to="/about">ABOUT</NavLink>
              {/* <NavLink to="/equipment-gallery">EQUIPMENT/GALLERY</NavLink> */}
              <NavLink to="/contact">CONTACT</NavLink>
            </NavLinksContainer>
          )}
          {(isMobileView || isServerSide) && (
            <HamburgerButton onClick={() => setShowSidebar(true)}>
              <IconLink url={false} icon={circleMenu} color="#fff" size="32px" noPadding />
            </HamburgerButton>
          )}
          {(isMobileView || isServerSide) && (
            <Sidebar forwardRef={sidebarRef} show={showSidebar} setShow={setShowSidebar} />
          )}
        </NavContainer>
      </HeaderContainer>
    </Fragment>
  );
};
